module.exports = __webpack_public_path__ + "static/media/image-5.8cf5ce27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-nuevo/image-5.jpg
// module id = 258
// module chunks = 0